'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// @flow

var DataLoader = require('./DataLoader');

var TeamMembersLoader = function (_DataLoader) {
  _inherits(TeamMembersLoader, _DataLoader);

  function TeamMembersLoader(firebase) {
    _classCallCheck(this, TeamMembersLoader);

    return _possibleConstructorReturn(this, (TeamMembersLoader.__proto__ || Object.getPrototypeOf(TeamMembersLoader)).call(this, firebase, 'teams', 'members', true));
  }

  _createClass(TeamMembersLoader, [{
    key: 'getFinalRef',
    value: function getFinalRef(dbRef) {
      return dbRef.orderByChild('displayName');
    }
  }]);

  return TeamMembersLoader;
}(DataLoader);

module.exports = TeamMembersLoader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/clients/loaders/TeamMembersLoader.js
// module id = 1019
// module chunks = 0